var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgKlarna = function SvgKlarna(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 44,
    viewBox: "0 0 80 44"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1312 -2151)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 44,
    fill: "#f7fafa",
    "data-name": "Rechteck 15073",
    rx: 3,
    transform: "translate(1312 2151)"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Gruppe 2097"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Gruppe 2096",
    transform: "translate(1325.16 2158.311)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 31,
    fill: "#ffb3c7",
    "data-name": "Rechteck 15139",
    rx: 4.321,
    transform: "translate(-.16 -.311)"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Gruppe 2095"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0a0b09",
    d: "M49.568 17.797a1.307 1.307 0 1 0 1.295 1.31 1.3 1.3 0 0 0-1.3-1.307Zm-4.261-1.011a1.872 1.872 0 0 0-3.74 0 1.872 1.872 0 0 0 3.74 0m.007-3.479h2.064v6.955h-2.064v-.443a3.6 3.6 0 0 1-2.046.637 3.67 3.67 0 0 1 0-7.34 3.6 3.6 0 0 1 2.046.637zm-16.516.906v-.906h-2.113v6.955h2.118v-3.245c0-1.1 1.177-1.684 1.993-1.684h.025v-2.026a2.56 2.56 0 0 0-2.023.905Zm-5.263 2.573a1.872 1.872 0 0 0-3.74 0 1.872 1.872 0 0 0 3.74 0m.006-3.479h2.064v6.955h-2.064v-.443a3.6 3.6 0 0 1-2.046.637 3.67 3.67 0 0 1 0-7.34 3.6 3.6 0 0 1 2.046.637zm12.422-.186a2.5 2.5 0 0 0-2.126.971v-.785h-2.055v6.955h2.081v-3.655a1.46 1.46 0 0 1 1.549-1.576c.907 0 1.428.547 1.428 1.561v3.669h2.061v-4.42a2.74 2.74 0 0 0-2.938-2.719Zm-21.111 7.143h2.16V10.207h-2.16zm-9.489.003h2.288v-10.06H5.363Zm8-10.06a8.04 8.04 0 0 1-2.34 5.71l3.162 4.35h-2.822l-3.439-4.728.887-.67a5.8 5.8 0 0 0 2.314-4.662z",
    "data-name": "Pfad 1704"
  })))))));
};
export default SvgKlarna;